import { AnimatePresence, motion } from "framer-motion";
import "../CSS/ContactLetter.scss"

const ContactLetter = ({formValues, submitForm, setFormValues, invalidName}) =>{

    return(
        <form className="letter-container" onSubmit={submitForm} id="form" name="Contact" 
        data-netlify="true" data-netlify-honeypot="bot-field">
            <input type="hidden" name="bot-field"/>
            <input type="hidden" name="form-name" value="Contact" />
            <div className="letter-heading">
                <input type="text" htmlFor="name" placeholder="Name"  maxLength="20" required name="name"
                    onChange={(e) => setFormValues({...formValues, name: e.target.value})}></input>
                    <AnimatePresence>
                        {invalidName && (
                            <motion.span className="invalid-name"
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            transition={{duration: .5}}>
                                This is not a valid name!</motion.span>
                        )}
                    </AnimatePresence>
                <input type="email" htmlFor="email" placeholder="Email"  maxLength="30" required name="email"
                    onChange={(e) => setFormValues({...formValues, email: e.target.value})}></input>
                <textarea placeholder="Message..." maxLength="400" required
                 onChange={(e) => setFormValues({...formValues, message: e.target.value})} name="message">

                </textarea>
            </div>
        </form>
    )
}

export default ContactLetter;